import React, { Component } from 'react';

import { TableExhibit2 as DataTable2 } from './table.component';
import { PaginationExhibit1 as Pagination1, PaginationExhibit2 as Pagination2 } from './pagination.component';

export class TablePaginationExhibit1 extends Component {
    constructor(props) {
        super(props);
        this.onColumnClickAction = this.onColumnClickAction.bind(this);
        this.state = {
            columns: {},
            pageList: []
        }
    }

    componentDidMount() {
        this.setState({
            columns: { ...this.props.columns },
            pageList: this.props.pageList
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.columns !== this.props.columns || prevProps.pageList !== this.props.pageList) {
            this.setState({
                columns: { ...this.props.columns },
                pageList: this.props.pageList
            });
        }
    }

    onColumnClickAction = (columnClicked) => {
        const { columns, pageList } = this.state;
        const arrayColumns = [];
        let updatedColumns = {};
        Object.entries(columns).map(x => {
            arrayColumns.push(x);
        });

        let currColumn = arrayColumns.slice().filter(currCol => columnClicked === currCol[0])[0];
        Object.keys(columns).forEach(function (key) {
            if (key === currColumn[0]) {
                updatedColumns[key] = { ...columns[key]};
                updatedColumns[key].isSortedAsc = !currColumn[1].isSortedAsc;
                updatedColumns[key].isSorted = true;
            } else {
                updatedColumns[key] = { ...columns[key] };
                updatedColumns[key].isSortedAsc = true;
                updatedColumns[key].isSorted = false;
            }
        });

        this.props.sortAction(columnClicked, !currColumn[1].isSortedAsc);
        this.setState(prevState => ({
            columns: updatedColumns,
            //pageList: copyAndSort(prevState.pageList, currColumn[0], currColumn[1].isSortedAsc, currColumn[1].isDateTime)
        }));

    };

    // render() {
    //     return (
    //         <div>
    //             <DataTable1
    //                 onColumnClick={this.onColumnClickAction}
    //                 rowClickAction={this.props.rowClickAction}
    //                 columns={this.state.columns}
    //                 pageList={this.state.pageList} />
    //             <Pagination1 pages={this.props.pages} action={this.props.paginationAction} />
    //         </div>
    //     )
    // }

}

export class TablePaginationExhibit2 extends Component {
    constructor(props) {
        super(props);
        this.onColumnClickAction = this.onColumnClickAction.bind(this);
        this.state = {
            columns: {},
            pageList: []
        }
    }

    componentDidMount() {
        this.setState({
            columns: { ...this.props.columns },
            pageList: this.props.pageList
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.columns !== this.props.columns || prevProps.pageList !== this.props.pageList) {
            this.setState({
                columns: { ...this.props.columns },
                pageList: this.props.pageList
            });
        }
    }

    onColumnClickAction = (columnClicked) => {
        const { columns, pageList } = this.state;
        const arrayColumns = [];
        let updatedColumns = {};
        Object.entries(columns).map(x => {
            arrayColumns.push(x);
        });

        let currColumn = arrayColumns.slice().filter(currCol => columnClicked === currCol[0])[0];
        Object.keys(columns).forEach(function (key) {
            if (key === currColumn[0]) {
                updatedColumns[key] = { ...columns[key] };
                updatedColumns[key].isSortedAsc = !currColumn[1].isSortedAsc;
                updatedColumns[key].isSorted = true;
            } else {
                updatedColumns[key] = { ...columns[key] };
                updatedColumns[key].isSortedAsc = true;
                updatedColumns[key].isSorted = false;
            }
        });

        this.props.onColumnClick(columnClicked, !currColumn[1].isSortedAsc);
        this.setState(prevState => ({
            columns: updatedColumns,
            //pageList: copyAndSort(prevState.pageList, currColumn[0], currColumn[1].isSortedAsc, currColumn[1].isDateTime)
        }));
    };

    onColumnSearch = (value) => {
        this.props.onColumnSearch(value);
    };

    onColumnSearchChange = (event, value) => {
        this.props.onColumnSearchChange(event, value);
    };

    render() {
        const {
            isColSearchShow,
            pages,
            paginationAction,
            resizePage,
            rowClickAction
        } = this.props;

        const {
            columns,
            pageList
        } = this.state;

        return (
            <div>
                <DataTable2
                    isLoading={this.props.isLoading}
                    isNotSortable={this.props.isNotSortable}
                    onColumnClick={this.onColumnClickAction}
                    rowClickAction={rowClickAction}
                    columns={columns}
                    pageList={pageList}
                    isColSearchShow={isColSearchShow}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={this.onColumnSearchChange}
                    haveLink={this.props.haveLink}
                    tableClassName={this.props.tableClassName}
                />
                <Pagination2 pages={pages} pageLength={this.props.totalPage} action={paginationAction} resizePage={resizePage} />
            </div>
        )
    }
}